import { useState, useCallback, useEffect, useRef } from 'react';
import { cloneDeep } from 'lodash-es';
import { useDispatch } from 'react-redux';
import { searchExcludeAPI } from 'services/searchExcludeAPI.service';

export const useToggleState = (
  selectedAdvetisers = [],
  foundedAdvetisers = [],
  setSearch,
  setSelectedAdvertisers,
  search,
  setIsOpen,
) => {
  const [state, stateSet] = useState(selectedAdvetisers);
  const flag = useRef(true);
  const dispatch = useDispatch();

  useEffect(() => {
    stateSet(selectedAdvetisers);
  }, [selectedAdvetisers]);

  const restore = useCallback(() => {
    stateSet(selectedAdvetisers);
    flag.current = true;
  }, [selectedAdvetisers]);

  const isActive = useCallback(
    (pb_number) => {
      return state.find((adv) => adv?.pb_number === pb_number) ? true : false;
    },
    [state],
  );

  const deleteItem = (pb_number) => {
    let newItems = cloneDeep(state);
    newItems = newItems.filter((adv) => adv?.pb_number !== pb_number);
    stateSet(newItems);
    flag.current = false;
  };

  const findItem = (pb_number, foundedAdvetisers) => {
    return foundedAdvetisers?.concat(state)?.find((adv) => adv?.pb_number === pb_number);
  };

  const addItem = (obj) => {
    let newItems = cloneDeep(state);
    newItems = newItems.concat(obj);
    stateSet(newItems);
    flag.current = false;
  };

  const toggle = useCallback(
    (checked, pb_number) => {
      return isActive(pb_number)
        ? deleteItem(pb_number)
        : addItem(findItem(pb_number, foundedAdvetisers));
    },
    [isActive, foundedAdvetisers],
  );

  const handleSaveSelectedAdvertisers = useCallback(() => {
    setSelectedAdvertisers(state);
    setIsOpen(false);
    dispatch(searchExcludeAPI.util.resetApiState());
    setSearch('');
    flag.current = true;
  }, [state]);

  const handleSearchOnChange = useCallback((e) => {
    setSearch(e.target.value || '');
  }, []);

  const handleClearSearchValue = useCallback(() => {
    setSearch('');
  }, []);

  const itemsToShow = useCallback(() => {
    if (!search) return state;
    if (search) return foundedAdvetisers;
  }, [foundedAdvetisers, search]);

  return {
    isActive,
    toggle,
    handleSaveSelectedAdvertisers,
    handleSearchOnChange,
    handleClearSearchValue,
    itemsToShow,
    restore,
    flag,
  };
};
